const MODE_KEYS = new Set(['brainstorm_mode', 'debug_mode', 'tdd_mode', 'verification_mode']);

const REAL_PLATFORMS = new Set([
  'linear',
  'lark',
  'feishu',
  'slack',
  'discord',
  'telegram',
  'wecom',
  'dingtalk',
  'line',
  'wechat',
  'qq',
  'qqbot',
]);

export function isRealPersonaPlatform(platform: unknown): platform is string {
  if (!platform) return false;
  const raw = String(platform).trim();
  const lower = raw.toLowerCase();
  if (/^[A-Z0-9_]+_MODE$/.test(raw)) return false;
  if (MODE_KEYS.has(lower)) return false;
  return REAL_PLATFORMS.has(lower);
}

export function filterRealPersonaPlatforms(platforms: unknown[]) {
  return Array.from(new Set(platforms.filter(isRealPersonaPlatform).map(platform => platform.toLowerCase())));
}
